module.exports = __webpack_public_path__ + "static/shipper-3-30f3fc3cea1214db86b10c0339db30e3.png";